export default "__VITE_ASSET__b5120355__"